import comp from "./PostCard";
export default comp;
